(function () {
  'use strict';

  var money = function (cents) {
    if (window.ZF && window.ZF.moneyFormat) {
      var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
      return window.ZF.moneyFormat
        .replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, Number(amount).toLocaleString('en-EG'))
        .replace(/<[^>]+>/g, '');
    }
    return (cents / 100).toFixed(2);
  };

  /* ---------- styled confirm dialog ---------- */
  var zfConfirm = function (message, yesLabel) {
    return new Promise(function (resolve) {
      var wrap = document.createElement('div');
      wrap.className = 'cfm';
      wrap.innerHTML =
        '<div class="cfm-box" role="alertdialog" aria-modal="true">' +
        '<p></p>' +
        '<div class="cfm-btns">' +
        '<button type="button" class="btn btn-lime" data-cfm-yes></button>' +
        '<button type="button" class="btn btn-ghost" data-cfm-no>إلغاء</button>' +
        '</div></div>';
      wrap.querySelector('p').textContent = message;
      wrap.querySelector('[data-cfm-yes]').textContent = yesLabel || 'موافق';
      document.body.appendChild(wrap);
      requestAnimationFrame(function () { wrap.classList.add('show'); });
      var close = function (val) {
        document.removeEventListener('keydown', onEsc);
        wrap.classList.remove('show');
        setTimeout(function () { wrap.remove(); }, 220);
        resolve(val);
      };
      var onEsc = function (e) {
        if (e.key === 'Escape') close(false);
      };
      wrap.querySelector('[data-cfm-yes]').addEventListener('click', function () { close(true); });
      wrap.querySelector('[data-cfm-no]').addEventListener('click', function () { close(false); });
      wrap.addEventListener('click', function (e) { if (e.target === wrap) close(false); });
      document.addEventListener('keydown', onEsc);
      wrap.querySelector('[data-cfm-no]').focus();
    });
  };
  var CLEAR_CART_MSG = 'في منتجات تانية في سلتك — الشراء المباشر هيمسحها ويكمل الطلب بالمنتج ده بس. تكمل؟';

  /* ---------- mobile nav drawer ---------- */
  var mnav = document.querySelector('.mnav');
  var mnavOverlay = document.querySelector('[data-menu-overlay]');
  var menuOpenBtn = document.querySelector('[data-menu-open]');
  if (mnav && menuOpenBtn) {
    /* ═══════════════════════════════════════════════════════════════
     * زرار الرجوع بتاع التليفون
     *
     * 🔴 المشكلة اللي اتصلّحت: المنيو كان بيحط حالة في التاريخ لما
     *    تفتح **لوحة داخلية** بس. فلو العميل فتح المنيو وضغط رجوع وهو
     *    على المستوى الأول، المتصفح كان بيطلّعه **من الموقع** بدل ما
     *    يقفل المنيو.
     *
     * 🔑 الحل: حالة واحدة «حارسة» طول ما المنيو مفتوح، بتتسلّح من جديد
     *    كل ما نرجع مستوى. فالرجوع بيمشي درجة واحدة في كل مرة:
     *      لوحة داخلية → المستوى الأول → المنيو يتقفل → الصفحة اللي قبلها
     *
     * ⚠️ وصاحب الحالة **واحد بس** — الموديول ده. موديول الدريل-داون
     *    بيغيّر الواجهة بس ومابيلمسش التاريخ، وإلا الاتنين بياكلوا نفس
     *    الحالة ويحصل تهييس.
     * ═══════════════════════════════════════════════════════════════ */
    var armed = false;      /* فيه حالة حارسة في التاريخ دلوقتي؟ */
    var skipPop = false;    /* الـpopstate الجاي من عندنا — تجاهله */
    var goingTo = null;     /* لينك مستنّي لما ننضّف التاريخ */

    var drill = function () { return window.ZFMnavDrill || null; };
    var inPanel = function () { var d = drill(); return !!(d && d.inPanel()); };

    var arm = function () {
      if (armed) return;
      try { history.pushState({ zfMnav: 1 }, ''); armed = true; } catch (e) { /* مش مهم */ }
    };
    var disarm = function () {
      if (!armed) return;
      armed = false;
      skipPop = true;
      try { history.back(); } catch (e) { skipPop = false; }
    };

    var setMenu = function (open, keepHistory) {
      mnav.classList.toggle('open', open);
      if (mnavOverlay) mnavOverlay.classList.toggle('open', open);
      menuOpenBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      var closeBtn = mnav.querySelector('[data-menu-close]');
      if (open && closeBtn) closeBtn.focus();
      if (!open) {
        var d = drill();
        if (d) d.toLevel0();        /* يفتح تاني من الأول مش من جوه لوحة */
        menuOpenBtn.focus();
      }
      if (keepHistory) return;
      if (open) arm(); else disarm();
    };

    menuOpenBtn.addEventListener('click', function () { setMenu(true); });

    mnav.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-close]')) { setMenu(false); return; }
      /* لينك جوه المنيو: ننضّف الحالة الحارسة **قبل** ما نروح، وإلا
       * بتفضل في التاريخ وضغطة رجوع من الصفحة الجديدة تضيع في العدم. */
      var a = e.target.closest('a[href]');
      if (!a || !mnav.contains(a) || !armed) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
      if (a.target && a.target !== '_self') return;
      e.preventDefault();
      goingTo = a.href;
      armed = false;
      try { history.back(); } catch (err) { goingTo = null; window.location.href = a.href; }
    });

    if (mnavOverlay) mnavOverlay.addEventListener('click', function () { setMenu(false); });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !mnav.classList.contains('open')) return;
      /* إسكيب جوه لوحة بيرجّع مستوى واحد — الدريل-داون بيمسكها */
      if (inPanel()) return;
      setMenu(false);
    });

    /* ⚠️ الرجوع من صفحة تانية بيسترجع الصفحة من كاش المتصفح **بحالتها**،
     * يعني المنيو بيرجع مفتوح زي ما سابه — والحالة الحارسة مابقتش موجودة،
     * فضغطة رجوع تانية كانت هتطلّعه من الموقع والمنيو قدامه مفتوح. */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && mnav.classList.contains('open')) {
        armed = false;
        setMenu(false, true);
      }
    });

    window.addEventListener('popstate', function () {
      if (goingTo) { var u = goingTo; goingTo = null; window.location.href = u; return; }
      if (skipPop) { skipPop = false; return; }
      if (!armed) return;                 /* مش حالتنا — سيب المتصفح يشتغل */
      armed = false;
      if (inPanel()) {
        drill().toLevel0();               /* درجة واحدة لجوه */
        arm();                            /* وسلّح تاني للضغطة الجاية */
      } else {
        setMenu(false, true);             /* المستوى الأول → اقفل بس */
      }
    });
  }

  /* ---------- quantity steppers (delegated) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var box = btn.closest('.qty');
    var input = box && box.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val = btn.dataset.qty === 'up' ? val + 1 : Math.max(parseInt(input.min, 10) || 1, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product page ---------- */
  var pform = document.getElementById('ProductForm');
  if (pform) {
    var dataEl = document.getElementById('ProductJson');
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;

    /* قاعدة الخصم التلقائي للمنتج ده — السيرفر بيحطها في ZFDisc عن طريق
       ميتافيلد المتجر. بتبقى null لو مفيش خصم، وبنتعامل مع أي شكل غلط
       على إنه «مفيش خصم» عشان صفحة المنتج متتكسرش أبدًا. */
    var zfDisc = null;
    try {
      var discEl = document.getElementById('ZFDisc');
      if (discEl) {
        var parsed = JSON.parse(discEl.textContent);
        if (parsed && (parsed.t === 'pct' || parsed.t === 'amt') && parsed.v > 0) {
          zfDisc = parsed;
        }
      }
    } catch (e) {}
    var idInput = pform.querySelector('input[name="id"]');
    var priceNow = document.querySelector('[data-price-now]');
    var priceWas = document.querySelector('[data-price-was]');
    var priceSave = document.querySelector('[data-price-save]');
    var stockEl = document.querySelector('[data-stock]');
    var addBtn = pform.querySelector('[data-add-btn]');
    var buyBtn = pform.querySelector('[data-buy-btn]');
    var barPrice = document.querySelector('[data-bar-price]');
    var returnTo = pform.querySelector('input[name="return_to"]');

    var currentVariant = function () {
      if (!product) return null;
      var groups = document.querySelectorAll('[data-option-index]');
      if (!groups.length) {
        var id = idInput && parseInt(idInput.value, 10);
        return product.variants.find(function (v) { return v.id === id; }) || product.variants[0];
      }
      var picked = [];
      groups.forEach(function (group) {
        var on = group.querySelector('button.on');
        picked[parseInt(group.dataset.optionIndex, 10)] = on ? on.dataset.value : null;
      });
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return picked[i] == null || opt === picked[i]; });
      });
    };

    var refresh = function () {
      var v = currentVariant();
      if (!v) {
        if (addBtn) {
          addBtn.disabled = true;
          var lbl = addBtn.querySelector('span');
          if (lbl) lbl.textContent = 'نفدت الكمية';
        }
        if (buyBtn) {
          buyBtn.disabled = true;
          var buyLblNA = buyBtn.querySelector('span');
          if (buyLblNA) buyLblNA.textContent = 'نفدت الكمية';
        }
        return;
      }
      if (idInput) idInput.value = v.id;

      /* الخصم التلقائي: Shopify مبتعرضهوش في صفحة المنتج، والسيرفر
         بيحطلنا قاعدته في ZFDisc. لازم نعيد حسابه هنا كمان عشان السعر
         يفضل مظبوط لما العميل يغيّر الطعم. */
      var eff = v.price;
      var ref = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : 0;
      if (zfDisc) {
        var off = zfDisc.t === 'pct'
          ? Math.round(v.price * zfDisc.v / 100)
          : (zfDisc.t === 'amt' ? zfDisc.v : 0);
        /* نفس حواجز الأمان اللي في الليكويد — لو الخصم أكبر من السعر
           منعرضوش بدل ما نطلع رقم سالب. */
        if (off > 0 && off < v.price) {
          eff = v.price - off;
          if (ref < v.price) ref = v.price;
        }
      }

      if (priceNow) priceNow.textContent = money(eff);
      if (barPrice) barPrice.textContent = money(eff);
      if (priceWas) {
        if (ref > eff) {
          priceWas.textContent = money(ref);
          priceWas.hidden = false;
          if (priceSave) {
            /* نفس منطق `snippets/auto-discount.liquid` بالظبط:
               النسبة من (المشطوب − الجديد) ÷ المشطوب، مقرّبة **لتحت**
               عشان ما نوعدش العميل بأكتر من اللي هياخده. ولو طلعت صفر
               (خصم أقل من ١٪) بنرجع للمبلغ. */
            var saveAmt = ref - eff;
            var pct = ref > 0 ? Math.floor((saveAmt * 100) / ref) : 0;
            priceSave.textContent = (window.ZF && window.ZF.discDisplay === 'percent' && pct > 0)
              ? 'خصم ' + pct + '٪'
              : 'خصم ' + money(saveAmt);
            priceSave.hidden = false;
          }
        } else {
          priceWas.hidden = true;
          if (priceSave) priceSave.hidden = true;
        }
      }
      if (stockEl) {
        stockEl.innerHTML = v.available
          ? '<span class="ok">متوفر — بيتشحن خلال ٢٤ ساعة</span>'
          : '<span class="no">نفدت الكمية حاليًا</span>';
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.querySelector('span') && (addBtn.querySelector('span').textContent = v.available ? 'أضف إلى السلة' : 'نفدت الكمية');
      }
      if (buyBtn) {
        buyBtn.disabled = !v.available;
        var buyLbl = buyBtn.querySelector('span');
        if (buyLbl) buyLbl.textContent = v.available ? (buyBtn.dataset.label || 'اشتري الآن') : 'نفدت الكمية';
      }
      var barBtn = document.querySelector('[data-bar-btn]');
      if (barBtn) {
        barBtn.disabled = !v.available;
        barBtn.textContent = v.available ? 'أضف إلى السلة' : 'نفدت الكمية';
      }
      if (v.featured_media && v.featured_media.id !== currentMediaId) {
        var vsrc = variantImageSrc(v);
        if (vsrc) {
          currentMediaId = v.featured_media.id;
          swapMain(vsrc, v.featured_media.alt || '');
          markThumb(document.querySelector('.thumbs .th[data-media-id="' + v.featured_media.id + '"]'));
        }
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    };

    document.querySelectorAll('[data-option-index] button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('[data-option-index]').querySelectorAll('button').forEach(function (b) { b.classList.remove('on'); });
        btn.classList.add('on');
        var label = btn.closest('.vgroup').querySelector('.vl small');
        if (label) label.textContent = btn.dataset.value;
        refresh();
      });
    });

    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        var submitNow = function () {
          /* ⚠️ /cart مش /checkout: صفحة السلة هي بوابة العنوان (محافظة/منطقة/حي).
             لو رجّعناها للشيك أوت، الأوردر بيوصل من غير بيانات بوسطة. */
          if (returnTo) returnTo.value = '/cart';
          pform.dataset.zfBuy = '1';
          if (typeof pform.requestSubmit === 'function') pform.requestSubmit();
          else pform.submit();
        };
        var bubble = document.querySelector('[data-cart-count]');
        var count = bubble ? parseInt(bubble.textContent, 10) || 0 : 0;
        if (!count) { submitNow(); return; }
        zfConfirm(CLEAR_CART_MSG, 'موافق، كمّل الشراء').then(function (ok) {
          if (!ok) return;
          buyBtn.classList.add('busy');
          fetch('/cart/clear.js', { method: 'POST' })
            .catch(function () {})
            .then(function () { submitNow(); });
        });
      });
    }

    /* add-to-cart via AJAX: stays on the page, updates the cart bubble */
    var ajaxAdd = function (btn) {
      var v = currentVariant();
      if (!v || !v.available || btn.classList.contains('busy')) return;
      btn.classList.add('busy');
      var qtyInput = pform.querySelector('input[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      (btn.dataset.one === '1'
        ? zfSetOne(v.id)
        : fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: v.id, quantity: qty })
        }))
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (btn.dataset.one === '1' && zfCapSamples(cart, v.id)) {
            btn.classList.remove('busy');
            return;
          }
          var bubble = document.querySelector('[data-cart-count]');
          if (bubble) {
            bubble.textContent = cart.item_count;
            bubble.classList.remove('bump');
            void bubble.offsetWidth;
            bubble.classList.add('bump');
          }
          if (window.ZFCartRefresh) window.ZFCartRefresh();
          btn.classList.remove('busy');
          btn.classList.add('added');
          var lbl = btn.querySelector('span') || btn;
          var orig = lbl.textContent;
          lbl.textContent = 'اتضاف للسلة ✓';
          setTimeout(function () {
            lbl.textContent = orig;
            btn.classList.remove('added');
          }, 2000);
        })
        .catch(function () {
          btn.classList.remove('busy');
          if (returnTo) returnTo.value = '/cart';
          pform.submit();
        });
    };
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        ajaxAdd(addBtn);
      });
    }
    var barBtn = document.querySelector('[data-bar-btn]');
    if (barBtn) {
      barBtn.addEventListener('click', function () { ajaxAdd(barBtn); });
    }

    /* gallery: preloaded fast swaps + variant sync + lightbox zoom */
    var mainWrap = document.querySelector('[data-main-media]');
    var mainImg = mainWrap ? mainWrap.querySelector('img') : null;
    var galThumbs = document.querySelectorAll('.thumbs .th');
    var openGalleryAt;   /* بيتعرّف تحت مع اللايت بوكس — شوف مصغّرة «+N» */
    var galRM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var currentMediaId = mainWrap ? parseInt(mainWrap.dataset.mediaId, 10) || 0 : 0;

    var markThumb = function (th) {
      galThumbs.forEach(function (t) { t.classList.remove('on'); });
      if (th) th.classList.add('on');
    };

    var swapMain = function (src, alt) {
      if (!mainImg || !src || mainImg.src === src) return;
      var apply = function () {
        mainImg.src = src;
        mainImg.srcset = '';
        if (alt) mainImg.alt = alt;
      };
      var pre = new Image();
      pre.src = src;
      if (galRM) { apply(); return; }
      mainWrap.classList.add('swapping');
      var started = Date.now();
      var done = function () {
        var wait = Math.max(0, 170 - (Date.now() - started));
        setTimeout(function () {
          apply();
          var show = function () { mainWrap.classList.remove('swapping'); };
          if (mainImg.decode) mainImg.decode().catch(function () {}).then(show);
          else requestAnimationFrame(show);
        }, wait);
      };
      if (pre.complete) done();
      else { pre.onload = done; pre.onerror = done; }
    };

    galThumbs.forEach(function (th) {
      th.addEventListener('click', function () {
        /* المصغّرة اللي عليها «+N» بتفتح المعرض عند أول صورة مخفية
           بدل ما تبدّل الصورة الكبيرة — ده اللي البادج بيوعد بيه. */
        var moreFrom = parseInt(th.dataset.moreFrom, 10);
        if (moreFrom >= 0 && typeof openGalleryAt === 'function') {
          openGalleryAt(moreFrom);
          return;
        }
        markThumb(th);
        currentMediaId = parseInt(th.dataset.mediaId, 10) || 0;
        var img = th.querySelector('img');
        if (img) swapMain(img.dataset.full || img.src, img.alt);
      });
    });

    var variantImageSrc = function (v) {
      if (!v || !v.featured_media || !v.featured_media.preview_image) return null;
      var s = v.featured_media.preview_image.src;
      return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=1100';
    };

    /* warm the cache so thumb/variant switches feel instant */
    if (mainImg) {
      var preloadGallery = function () {
        document.querySelectorAll('.thumbs .th img[data-full]').forEach(function (img) {
          new Image().src = img.dataset.full;
        });
        if (product) {
          product.variants.forEach(function (v) {
            var s = variantImageSrc(v);
            if (s) new Image().src = s;
          });
        }
      };
      if ('requestIdleCallback' in window) requestIdleCallback(preloadGallery, { timeout: 3000 });
      else setTimeout(preloadGallery, 1200);
    }

    /* lightbox */
    if (mainImg) {
      var lbx = null;
      var lbxImg = null;
      var lbxDragged = false;
      var lbxIndex = 0;
      var lbxList = [];
      if (product && product.media && product.media.length) {
        product.media.forEach(function (m) {
          if ((!m.media_type || m.media_type === 'image') && m.preview_image) {
            lbxList.push({ id: m.id, src: m.preview_image.src });
          }
        });
      }
      var lbxSized = function (src) {
        return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=2048';
      };
      var lbxClose = function () {
        if (!lbx) return;
        lbx.classList.remove('open', 'zoomed');
        document.documentElement.style.overflow = '';
      };
      var lbxCount = function () {
        var el = lbx.querySelector('.lbx-count');
        if (el && lbxList.length > 1) {
          el.textContent = (lbxIndex + 1).toLocaleString('ar-EG') + ' / ' + lbxList.length.toLocaleString('ar-EG');
        }
      };
      var lbxWarmed = false;
      var lbxWarm = function () {
        if (lbxWarmed) return;
        lbxWarmed = true;
        lbxList.forEach(function (m) { new Image().src = lbxSized(m.src); });
      };
      var lbxGo = function (i) {
        if (lbxList.length < 2) return;
        lbxIndex = (i + lbxList.length) % lbxList.length;
        lbx.classList.remove('zoomed');
        lbxCount();
        var src = lbxSized(lbxList[lbxIndex].src);
        var apply = function () {
          lbxImg.src = src;
          var done = function () { lbx.classList.remove('fading'); };
          if (lbxImg.decode) lbxImg.decode().catch(function () {}).then(done);
          else requestAnimationFrame(done);
        };
        if (galRM) { apply(); return; }
        lbx.classList.add('fading');
        var started = Date.now();
        var pre = new Image();
        pre.src = src;
        var ready = function () {
          var wait = Math.max(0, 140 - (Date.now() - started));
          setTimeout(apply, wait);
        };
        if (pre.complete) ready();
        else { pre.onload = ready; pre.onerror = ready; }
      };
      var lbxBuild = function () {
        var ARR = '<svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" d="M20 12H5m6-6-6 6 6 6"/></svg>';
        lbx = document.createElement('div');
        lbx.className = 'lbx';
        lbx.innerHTML =
          '<button type="button" class="lbx-x" aria-label="إغلاق">&#10005;</button>' +
          '<button type="button" class="lbx-nav lbx-prev" aria-label="الصورة السابقة"><span class="flip">' + ARR + '</span></button>' +
          '<button type="button" class="lbx-nav lbx-next" aria-label="الصورة التالية">' + ARR + '</button>' +
          '<span class="lbx-count"></span>' +
          '<div class="lbx-scroll"><img alt=""></div>';
        document.body.appendChild(lbx);
        lbxImg = lbx.querySelector('.lbx-scroll img');
        var scrollEl = lbx.querySelector('.lbx-scroll');
        lbx.querySelector('.lbx-x').addEventListener('click', lbxClose);
        lbx.querySelector('.lbx-next').addEventListener('click', function () { lbxGo(lbxIndex + 1); });
        lbx.querySelector('.lbx-prev').addEventListener('click', function () { lbxGo(lbxIndex - 1); });
        scrollEl.addEventListener('click', function (e) {
          if (e.target === scrollEl) lbxClose();
        });
        var swX = 0, swY = 0;
        scrollEl.addEventListener('touchstart', function (e) {
          swX = e.touches[0].clientX;
          swY = e.touches[0].clientY;
        }, { passive: true });
        scrollEl.addEventListener('touchend', function (e) {
          if (lbx.classList.contains('zoomed')) return;
          var dx = e.changedTouches[0].clientX - swX;
          var dy = e.changedTouches[0].clientY - swY;
          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            if (dx > 0) lbxGo(lbxIndex + 1);
            else lbxGo(lbxIndex - 1);
          }
        }, { passive: true });
        document.addEventListener('keydown', function (e) {
          if (!lbx.classList.contains('open')) return;
          if (e.key === 'Escape') lbxClose();
          else if (e.key === 'ArrowLeft') lbxGo(lbxIndex + 1);
          else if (e.key === 'ArrowRight') lbxGo(lbxIndex - 1);
        });
        lbxImg.addEventListener('click', function (e) {
          if (lbxDragged) { lbxDragged = false; return; }
          if (lbx.classList.contains('zoomed')) {
            lbx.classList.remove('zoomed');
          } else {
            var r = lbxImg.getBoundingClientRect();
            var rx = (e.clientX - r.left) / r.width;
            var ry = (e.clientY - r.top) / r.height;
            lbx.classList.add('zoomed');
            scrollEl.scrollLeft = lbxImg.offsetWidth * rx - scrollEl.clientWidth / 2;
            scrollEl.scrollTop = lbxImg.offsetHeight * ry - scrollEl.clientHeight / 2;
          }
        });
        lbxImg.addEventListener('mousedown', function (e) {
          if (!lbx.classList.contains('zoomed')) return;
          var sx = e.clientX, sy = e.clientY;
          var sl = scrollEl.scrollLeft, st = scrollEl.scrollTop;
          var move = function (ev) {
            if (Math.abs(ev.clientX - sx) + Math.abs(ev.clientY - sy) > 4) lbxDragged = true;
            scrollEl.scrollLeft = sl - (ev.clientX - sx);
            scrollEl.scrollTop = st - (ev.clientY - sy);
          };
          var up = function () {
            document.removeEventListener('mousemove', move);
            document.removeEventListener('mouseup', up);
          };
          document.addEventListener('mousemove', move);
          document.addEventListener('mouseup', up);
          e.preventDefault();
        });
      };
      var lbxOpen = function () {
        if (!lbx) lbxBuild();
        lbxIndex = 0;
        for (var i = 0; i < lbxList.length; i++) {
          if (lbxList[i].id === currentMediaId) { lbxIndex = i; break; }
        }
        if (lbxList.length) lbxImg.src = lbxSized(lbxList[lbxIndex].src);
        else lbxImg.src = (mainImg.currentSrc || mainImg.src).replace(/width=1100/, 'width=2048');
        lbxImg.alt = mainImg.alt || '';
        lbx.classList.toggle('single', lbxList.length < 2);
        lbxCount();
        lbx.classList.add('open');
        document.documentElement.style.overflow = 'hidden';
        lbxWarm();
      };
      mainImg.addEventListener('click', lbxOpen);
      var zoomBtn = document.querySelector('[data-zoom-open]');
      if (zoomBtn) zoomBtn.addEventListener('click', lbxOpen);

      /* بتتنده من مصغّرة «+N». `var` مرفوع لأول الدالة فالمستمع اللي
         اتسجّل فوق بيلاقيها وقت الضغط. ولو الصورة الكبيرة مش موجودة
         أصلًا بتفضل `undefined` والمستمع بيرجع للسلوك العادي. */
      openGalleryAt = function (i) {
        if (!lbx) lbxBuild();
        lbxIndex = Math.min(Math.max(i, 0), Math.max(lbxList.length - 1, 0));
        if (lbxList.length) lbxImg.src = lbxSized(lbxList[lbxIndex].src);
        lbxImg.alt = mainImg.alt || '';
        lbx.classList.toggle('single', lbxList.length < 2);
        lbxCount();
        lbx.classList.add('open');
        document.documentElement.style.overflow = 'hidden';
        lbxWarm();
      };
    }

    refresh();
  }

  /* ---------- collection sorting ---------- */
  var sortSel = document.querySelector('[data-sort]');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- cart page ---------- */
  var cartRoot = document.querySelector('[data-cart-root]');
  if (cartRoot) {
    var sectionId = cartRoot.dataset.sectionId;
    var busy = false;

    var rerender = function () {
      return fetch(window.location.pathname + '?section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-root]');
          if (fresh) cartRoot.innerHTML = fresh.innerHTML;
          var bubble = document.querySelector('[data-cart-count]');
          var freshCount = doc.querySelector('[data-cart-items-count]');
          if (bubble && freshCount) bubble.textContent = freshCount.dataset.cartItemsCount;
        });
    };

    var change = function (line, quantity) {
      if (busy) return;
      busy = true;
      cartRoot.style.opacity = '.55';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var bubble = document.querySelector('[data-cart-count]');
          if (bubble) bubble.textContent = c.item_count;
          if (window.ZFCartRefresh) window.ZFCartRefresh();
          return rerender();
        })
        .finally(function () { busy = false; cartRoot.style.opacity = ''; });
    };
    window.ZFCartPageRerender = rerender;

    cartRoot.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-qty]');
      if (input) change(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
    });
    var applyCoupon = function () {
      var field = cartRoot.querySelector('[data-coupon-input]');
      var code = field && field.value.trim();
      if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart';
    };

    cartRoot.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-line-remove]');
      if (rm) { e.preventDefault(); change(parseInt(rm.dataset.line, 10), 0); }
      var up = e.target.closest('[data-upsell-add]');
      if (up) {
        e.preventDefault();
        up.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(up.dataset.upsellAdd, 10), quantity: 1 })
        }).then(function () { return rerender(); });
      }
      var cp = e.target.closest('[data-coupon-apply]');
      if (cp) { e.preventDefault(); applyCoupon(); }
    });
    /* Enter في خانة الكوبون كان بيعمل submit للفورم والكود بيضيع */
    cartRoot.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target.closest('[data-coupon-input]')) return;
      e.preventDefault();
      applyCoupon();
    });
    cartRoot.addEventListener('change', function (e) {
      var note = e.target.closest('[data-cart-note]');
      if (note) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
      }
    });
  }

  /* ---------- motion: loadbar, reveal, image fade, busy buttons ---------- */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  requestAnimationFrame(function () { document.documentElement.classList.add('boot'); });

  var loadbar = document.createElement('div');
  loadbar.className = 'loadbar';
  loadbar.setAttribute('aria-hidden', 'true');
  loadbar.appendChild(document.createElement('i'));
  document.body.appendChild(loadbar);
  var startLoad = function () { document.documentElement.classList.add('is-loading'); };
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
    startLoad();
  });
  window.addEventListener('pageshow', function () {
    document.documentElement.classList.remove('is-loading');
    document.querySelectorAll('.btn.busy').forEach(function (b) { b.classList.remove('busy'); });
  });

  /* hover prefetch fallback for browsers without Speculation Rules */
  if (!(window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'))) {
    var prefetched = {};
    document.addEventListener('mouseover', function (e) {
      var a = e.target.closest('a[href]');
      if (!a || a.target === '_blank' || prefetched[a.href]) return;
      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return; }
      if (url.origin !== location.origin) return;
      if (/^\/(cart|checkout|account|challenge)/.test(url.pathname)) return;
      prefetched[a.href] = 1;
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = a.href;
      document.head.appendChild(l);
    });
  }

  if ('IntersectionObserver' in window && !reduceMotion) {
    var rvTargets = document.querySelectorAll('.sh, .pcard, .goal-card, .shots-car, .shots-grid > *, .grev-car, .grev-grid > *, .col-grid > *, .det-card');
    var rvIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); rvIo.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    rvTargets.forEach(function (t, i) {
      t.classList.add('rv');
      t.style.transitionDelay = (i % 4) * 45 + 'ms';
      rvIo.observe(t);
    });
  }

  if (!reduceMotion) {
    document.querySelectorAll('.ph img').forEach(function (im) {
      if (im.complete) return;
      im.classList.add('fdi');
      var done = function () { im.classList.add('ld'); };
      im.addEventListener('load', done, { once: true });
      im.addEventListener('error', done, { once: true });
    });
  }

  document.addEventListener('submit', function (e) {
    startLoad();
    if (e.target.id === 'ProductForm') {
      var rt = e.target.querySelector('input[name="return_to"]');
      var buy = e.target.querySelector('[data-buy-btn]');
      var add = e.target.querySelector('[data-add-btn]');
      var going = e.target.dataset.zfBuy ? buy : add;
      if (going) going.classList.add('busy');
    }
  });


  /*
   * 🔴 **الإضافة المتكررة كانت بتعدّي حد القطعة الواحدة.**
   * `/cart/add.js` **بيزوّد** على الكمية الموجودة، فخمس ضغطات على زرار
   * الإضافة = خمس قطع، حتى والزراير +/− مخفية. اتكشفت على الحي.
   * `/cart/update.js` **بيثبّت** الكمية وبيضيف الصنف لو مش موجود.
   * متحقق: ٣ ← ١، وعلى سلة فاضية ← ١.
   */
  function zfSetOne(variantId) {
    var u = {};
    u[String(variantId)] = 1;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: u })
    });
  }

  /*
   * حد عدد العينات في الأوردر.
   * 🔑 **العيّنة = سطر سعره صفر.** متحقق ٢١ أكتوبر: ٦٩ بسعر صفر و٦٩
   *    في قسم العينات — نفس المجموعة بالظبط، صفر استثناء.
   * 🔑 **الفحص بعد الإضافة.** الكود أصلًا بيجيب `/cart.js` بعد كل إضافة
   *    عشان يحدّث البابل — فبنعدّ من السلة اللي في إيدنا، مفيش طلب زيادة.
   * ⚠️ منع في الواجهة. اللي يعدّي بلينك مباشر لازم يتمسك من الباك-إند.
   */
  function zfCapSamples(cart, variantId) {
    var max = (window.ZF && parseInt(window.ZF.sampleMax, 10)) || 0;
    if (!max || !cart || !cart.items) return false;
    var n = cart.items.filter(function (i) { return i.final_price === 0; }).length;
    if (n <= max) return false;
    var u = {};
    u[String(variantId)] = 0;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: u })
    }).then(function () { if (window.ZFCartRefresh) window.ZFCartRefresh(); });
    zfSampleNote();
    return true;
  }
  function zfSampleNote() {
    var msg = (window.ZF && window.ZF.sampleNote) || '';
    if (!msg) return;
    var old = document.querySelector('.zf-samtoast');
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'zf-samtoast';
    el.setAttribute('role', 'status');
    /*
     * تحت الهيدر بالظبط. الهيدر لاصق (position:sticky) فحافته السفلية
     * على الشاشة هي اللي عايزينها — مش ارتفاعه — عشان تضبط سواء الصفحة
     * فوق خالص أو منزّلة.
     */
    var hdr = document.querySelector('.hdr');
    var below = hdr ? Math.round(hdr.getBoundingClientRect().bottom) : 0;
    el.style.setProperty('--samtoast-top', Math.max(12, below + 10) + 'px');
    el.setAttribute('tabindex', '0');
    el.textContent = msg;
    /* الضغط عليه بيفتح السلة — اللي عايز يفهم ليه اتمنع يشوف اللي معاه */
    el.addEventListener('click', function () {
      var open = document.querySelector('[data-cart-open]');
      if (open) open.click();
      el.remove();
    });
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('show'); });
    setTimeout(function () {
      el.classList.remove('show');
      setTimeout(function () { el.remove(); }, 320);
    }, 5000);
  }

  /* ---------- product recommendations ---------- */
  var reco = document.querySelector('[data-recommendations]');
  if (reco) {
    var url = reco.dataset.url;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) {
          reco.innerHTML = fresh.innerHTML;
        } else {
          var host = reco.closest('.sec');
          if (host) host.remove();
        }
      })
      .catch(function () {});
  }

  /* ---------- cart drawer ---------- */
  var cdRoot = document.querySelector('[data-cdrawer-root]');
  if (cdRoot) {
    var cdBusy = false;
    var cdOpen = function () {
      cdRoot.classList.add('open');
      document.documentElement.style.overflow = 'hidden';
      var aside = cdRoot.querySelector('.cdrawer');
      if (aside) aside.focus();
    };
    var cdClose = function () {
      cdRoot.classList.remove('open');
      document.documentElement.style.overflow = '';
    };
    window.ZFCartRefresh = function () {
      return fetch('/?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cdrawer-root]');
          if (fresh) cdRoot.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    };
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener) { e.preventDefault(); cdOpen(); return; }
      if (e.target.closest('[data-cdrawer-close]')) cdClose();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cdRoot.classList.contains('open')) cdClose();
    });
    var cdChange = function (line, quantity) {
      if (cdBusy) return;
      cdBusy = true;
      var items = cdRoot.querySelector('[data-cd-items]');
      if (items) items.style.opacity = '.55';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var bubble = document.querySelector('[data-cart-count]');
          if (bubble) bubble.textContent = c.item_count;
          if (window.ZFCartPageRerender) window.ZFCartPageRerender();
          return window.ZFCartRefresh();
        })
        .finally(function () { cdBusy = false; });
    };
    cdRoot.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-qty]');
      if (input) cdChange(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
    });
    cdRoot.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-line-remove]');
      if (rm) cdChange(parseInt(rm.dataset.line, 10), 0);
    });
  }

  /* ---------- product card quick add ---------- */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-card-add]');
    if (!qa) return;
    e.preventDefault();
    if (qa.classList.contains('busy') || qa.classList.contains('done')) return;
    qa.classList.add('busy');
    (qa.dataset.one === '1'
      ? zfSetOne(parseInt(qa.dataset.cardAdd, 10))
      : fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(qa.dataset.cardAdd, 10), quantity: 1 })
      }))
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (qa.dataset.one === '1'
          && zfCapSamples(cart, parseInt(qa.dataset.cardAdd, 10))) {
          qa.classList.remove('busy');
          return;
        }
        var bubble = document.querySelector('[data-cart-count]');
        if (bubble) {
          bubble.textContent = cart.item_count;
          bubble.classList.remove('bump');
          void bubble.offsetWidth;
          bubble.classList.add('bump');
        }
        if (window.ZFCartRefresh) window.ZFCartRefresh();
        qa.classList.remove('busy');
        qa.classList.add('done');
        var orig = qa.innerHTML;
        qa.innerHTML = '<svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.5 5 5 10-11"/></svg>';
        setTimeout(function () {
          qa.innerHTML = orig;
          qa.classList.remove('done');
        }, 1800);
      })
      .catch(function () { qa.classList.remove('busy'); });
  });

  /* ---------- product card buy now: direct checkout ---------- */
  document.addEventListener('click', function (e) {
    var qb = e.target.closest('[data-card-buy]');
    if (!qb || qb.classList.contains('busy')) return;
    e.preventDefault();
    var go = function () {
      qb.classList.add('busy');
      fetch('/cart/clear.js', { method: 'POST' })
        .catch(function () {})
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(qb.dataset.cardBuy, 10), quantity: 1 })
          });
        })
        .then(function (r) {
          if (!r || !r.ok) throw new Error('buy failed');
          window.location.href = '/cart';
        })
        .catch(function () { qb.classList.remove('busy'); });
    };
    var bubble = document.querySelector('[data-cart-count]');
    var count = bubble ? parseInt(bubble.textContent, 10) || 0 : 0;
    if (!count) go();
    else zfConfirm(CLEAR_CART_MSG, 'موافق، كمّل الشراء').then(function (ok) { if (ok) go(); });
  });

  /* ---------- horizontal snap carousels (wa shots + google reviews) ---------- */
  var carouselInit = function (root) {
    var track = root.querySelector('[data-shots-track]');
    if (!track || root.dataset.ready) return;
    root.dataset.ready = '1';
    var dir = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
    var step = function () {
      var item = track.firstElementChild;
      if (!item) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 14;
      return item.getBoundingClientRect().width + gap;
    };
    var atEnd = function () {
      return Math.abs(track.scrollLeft) + track.clientWidth >= track.scrollWidth - 4;
    };
    var fwd = function () {
      if (atEnd()) track.scrollTo({ left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      else track.scrollBy({ left: dir * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    var back = function () {
      track.scrollBy({ left: -dir * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    var ms = parseInt(root.dataset.interval, 10) || 0;
    var timer = null;
    var held = false;
    var seen = false;
    var play = function () {
      if (timer || !ms || reduceMotion || held || !seen || document.hidden) return;
      timer = setInterval(fwd, ms);
    };
    var stop = function () {
      if (timer) { clearInterval(timer); timer = null; }
    };
    var fwdBtn = root.querySelector('[data-shots-fwd]');
    var backBtn = root.querySelector('[data-shots-back]');
    if (fwdBtn) fwdBtn.addEventListener('click', fwd);
    if (backBtn) backBtn.addEventListener('click', back);
    root.addEventListener('mouseenter', function () { held = true; stop(); });
    root.addEventListener('mouseleave', function () { held = false; play(); });
    root.addEventListener('focusin', function () { held = true; stop(); });
    root.addEventListener('focusout', function () { held = false; play(); });
    track.addEventListener('touchstart', function () { held = true; stop(); }, { passive: true });
    track.addEventListener('touchend', function () { held = false; play(); }, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else play();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        seen = entries[0].isIntersecting;
        if (seen) play(); else stop();
      }, { threshold: 0.2 }).observe(root);
    } else {
      seen = true;
      play();
    }
  };
  document.querySelectorAll('[data-shots]').forEach(carouselInit);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-shots]').forEach(carouselInit);
  });
})();

/* ============================================================
 * تابات الميجا منيو — «أقسام المنتجات / البوكسات / تصفّح بهدفك»
 *
 * 🔴 الماركب كان موجود من غير أي جافاسكريبت: الأزرار و`role="tablist"`
 *    و`aria-controls` كلهم مكتوبين صح، بس مفيش كود بيستقبل الضغط.
 *    فالتابة الأولى بس كانت شغّالة — هي الوحيدة اللي مش `hidden`.
 *
 * ⚠️ الحركة لازم تتعاد مع كل تبديل تابة. قاعدة الـCSS مربوطة بـ
 *    `.ndrop[open]` فبتشتغل وقت فتح المنيو بس. هنا بنعيد تشغيلها يدويًا
 *    بإعادة تدفّق مقصودة (`offsetWidth`) — من غيرها اللينكات بتظهر
 *    فجأة من غير ستاجر.
 *
 * ⚠️ نمط ARIA للتابات بيطلب الأسهم كمان مش الضغط بس — ومن غيره
 *    الوصولية بتسقط.
 * ============================================================ */
(function () {
  var reduce = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function replay(panel) {
    if (reduce) return;
    var links = panel.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      a.style.animation = 'none';
      /* إجبار المتصفح يعيد الحساب — من غيرها السطر اللي بعده مالوش أثر */
      void a.offsetWidth;
      a.style.animation = '';
    }
  }

  function select(root, btn) {
    var tabs = root.querySelectorAll('[data-ndtab]');
    var panels = root.querySelectorAll('[data-ndpanel]');
    for (var i = 0; i < tabs.length; i++) {
      var on = tabs[i] === btn;
      tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      tabs[i].tabIndex = on ? 0 : -1;
    }
    var wanted = btn.getAttribute('aria-controls');
    for (var j = 0; j < panels.length; j++) {
      var show = panels[j].id === wanted;
      panels[j].hidden = !show;
      if (show) replay(panels[j]);
    }
  }

  function init(root) {
    if (root.dataset.ndtabsReady) return;
    root.dataset.ndtabsReady = '1';
    var tabs = root.querySelectorAll('[data-ndtab]');

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ndtab]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      select(root, btn);
    });

    /* الأسهم تنقّل بين التابات — شرط في نمط ARIA */
    root.addEventListener('keydown', function (e) {
      var btn = e.target.closest('[data-ndtab]');
      if (!btn) return;
      var list = Array.prototype.slice.call(tabs);
      var at = list.indexOf(btn);
      var to = -1;
      /* المنيو عربي RTL: السهم الشمال بيروح للي بعده */
      if (e.key === 'ArrowLeft') to = at + 1;
      else if (e.key === 'ArrowRight') to = at - 1;
      else if (e.key === 'Home') to = 0;
      else if (e.key === 'End') to = list.length - 1;
      else return;
      e.preventDefault();
      if (to < 0) to = list.length - 1;
      if (to >= list.length) to = 0;
      select(root, list[to]);
      list[to].focus();
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ndtabs]').forEach(init);
  }
  boot();
  /* المنيو جوه الهيدر — بيتعاد بناؤه لما سمير يعدّل في الكاستومايزر */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* ============================================================
 * دريل-داون منيو الموبايل — مستوى ٠ (المجموعات) ← مستوى ١ (الأقسام)
 *
 * 🔴 كل الماركب والـCSS كانوا موجودين من غير أي جافاسكريبت:
 *    `[data-mgo]` و`[data-mpanel]` و`[data-mback]` و`[data-mtitle]`
 *    وحتى `@keyframes mnPanel` — بس مفيش كود بيربطهم. فالضغط على
 *    «أقسام المنتجات» مكانش بيعمل حاجة.
 *
 * ⚠️ **زرار الرجوع في التليفون كمان.** بنحط حالة في التاريخ عند فتح
 *    اللوحة، فزرار الرجوع بتاع أندرويد (أو سحب الحافة في iOS) بيرجّع
 *    لمستوى ٠ بدل ما يطلّع العميل من الموقع خالص.
 *
 * ⚠️ الحركة لازم تتعاد مع كل فتح. توجيل `hidden` لوحده مش مضمون إنه
 *    يعيد تشغيل الأنيميشن في كل المتصفحات — فبنجبره بإعادة تدفّق.
 * ============================================================ */
(function () {
  var mnav = document.querySelector('.mnav');
  if (!mnav) return;

  var links = mnav.querySelector('.mnav-links');
  var brand = mnav.querySelector('.mnav-brand');
  var back = mnav.querySelector('[data-mback]');
  var title = mnav.querySelector('[data-mtitle]');
  var panels = mnav.querySelectorAll('[data-mpanel]');
  if (!links || !panels.length) return;

  var reduce = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function replay(el) {
    if (reduce) return;
    var nodes = [el].concat(Array.prototype.slice.call(el.querySelectorAll('a')));
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].style.animation = 'none';
      /* إجبار إعادة الحساب — من غيرها السطر اللي بعده مالوش أثر */
      void nodes[i].offsetWidth;
      nodes[i].style.animation = '';
    }
  }

  function toLevel0() {
    for (var i = 0; i < panels.length; i++) panels[i].hidden = true;
    links.hidden = false;
    if (brand) brand.hidden = false;
    if (back) back.hidden = true;
    if (title) { title.hidden = true; title.textContent = ''; }
  }

  function toPanel(btn) {
    var want = btn.getAttribute('data-mgo');
    var found = null;
    for (var i = 0; i < panels.length; i++) {
      var on = panels[i].getAttribute('data-mpanel') === want;
      panels[i].hidden = !on;
      if (on) found = panels[i];
    }
    if (!found) return;
    links.hidden = true;
    if (brand) brand.hidden = true;
    if (back) back.hidden = false;
    if (title) {
      title.textContent = btn.getAttribute('data-mtitle') || '';
      title.hidden = false;
    }
    replay(found);
    if (back) back.focus();
  }

  function inPanel() {
    for (var i = 0; i < panels.length; i++) if (!panels[i].hidden) return true;
    return false;
  }

  /* 🔑 الرجوع مجرد تغيير واجهة. **التاريخ كله بقى في موديول الدرج**
   * (`mobile nav drawer` فوق) عشان يبقى صاحب واحد للحالة — قبل كده
   * كان الموديول ده بيحط حالة عند فتح لوحة بس، فالباك وإحنا على
   * المستوى ٠ كان بيطلّع العميل من الموقع. */
  function goBack() { toLevel0(); }

  mnav.addEventListener('click', function (e) {
    var go = e.target.closest('[data-mgo]');
    if (go && mnav.contains(go)) { e.preventDefault(); toPanel(go); return; }
    if (e.target.closest('[data-mback]')) { e.preventDefault(); goBack(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (mnav.classList.contains('open') && inPanel()) {
      /* إسكيب جوه لوحة بيرجّع مستوى واحد مش بيقفل المنيو كله */
      e.stopImmediatePropagation();
      goBack();
    }
  }, true);

  /* موديول الدرج بيحتاجهم عشان يقرّر الباك يرجّع مستوى ولا يقفل */
  window.ZFMnavDrill = { toLevel0: toLevel0, inPanel: inPanel };

  toLevel0();
})();

/* ============================================================
 * الهيدر: يختفي وإنت نازل، ويظهر أول ما تطلع لفوق — قرار سمير ٣٠ أكتوبر
 *
 * ⚠️ الحركة بـ`top` مش `transform`: أي transform على `.hdr-sec` بيخلّي
 *    المنيو الجانبي (fixed جوه الهيدر) يتحسب على الهيدر بدل الشاشة —
 *    فلو العميل داس المنيو والهيدر لسه بينزل، المنيو يطلع مكسور.
 *    و`top` على عنصر sticky مابيزقّش الصفحة، فـCLS صفر.
 *
 * ⚠️ مايختفيش وفيه حاجة مفتوحة (المنيو/السلة/الصور بيقفلوا السكرول بـ
 *    `overflow:hidden`، وميجا منيو الديسكتوب `.ndrop[open]`) ولا والعميل
 *    بيكتب في البحث — كيبورد الموبايل بيحرّك الصفحة وكان هيخفيه.
 * ============================================================ */
(function () {
  var sec = document.querySelector('.hdr-sec');
  if (!sec) return;
  var root = document.documentElement;
  var hidden = false, ticking = false;
  var lastY = window.scrollY;

  function busy() {
    var a = document.activeElement;
    return root.style.overflow === 'hidden'
      || !!document.querySelector('.ndrop[open]')
      || !!sec.querySelector('.zfq-pop:not([hidden])')
      || !!(a && sec.contains(a) && a.matches('input, textarea, select'));
  }

  function set(h) {
    if (h === hidden) return;
    hidden = h;
    /* +8 عشان ضل/حدود الهيدر وشريط زينة «الإطار» (top:7px) مايبانوش */
    sec.style.top = h ? -(sec.offsetHeight + 8) + 'px' : '';
    root.classList.toggle('hdr-off', h);
  }

  function update() {
    ticking = false;
    /* محصور جوه الصفحة: ارتداد الآيفون في الأول والآخر مايتحسبش طلوع/نزول */
    var max = root.scrollHeight - window.innerHeight;
    var y = Math.min(Math.max(window.scrollY, 0), max);
    var dy = y - lastY;
    if (y < sec.offsetHeight + 40 || busy()) { lastY = y; set(false); return; }
    if (Math.abs(dy) < 8) return; /* رعشة الصباع — بتتجمع لحد ٨px */
    lastY = y;
    set(dy > 0);
  }

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }, { passive: true });

  /* الكيبورد: أي تركيز جوه الهيدر يظهّره */
  sec.addEventListener('focusin', function () { set(false); });
})();

/* ============================================================
 * البحث الفوري — فكرة Nexus (٣٠ أكتوبر) بس بفهرس بتاعنا
 *
 * 🔴 بحث شوبيفاي الفوري (`/search/suggest.json`) بيرفض العربي
 *    («Unsupported buyer locale»)، وبحث `/search` العادي بيرجّع ٣٨ نتيجة
 *    لـ«زززز». فالبيانات من sections/zf-search-index.liquid والمطابقة هنا.
 *
 * طلب سمير (٣٠ أكتوبر): اللوح فاضي قبل الكتابة · أمثلة بتتكتب وتتمسح في
 * الخانة (إعداد «أمثلة…» في الهيدر) · ٤ نتايج وزرار «كل النتايج» ← صفحة
 * /search نفسها، والكروت هناك بتتجاب من السيرفر بترتيبنا
 * (sections/zf-search-cards.liquid) — نفس الكارت بالخصم والنجوم.
 *
 * - التطبيع: أ/إ/آ=ا · ة=ه · ى=ي · من غير تشكيل · ٠-٩ = 0-9 · «ال» اختيارية
 *   · نطق الكلمات الإنجليزي اللي في الأسماء (Crea = كريا، X = اكس…).
 * - كل كلمة لازم تطابق بداية كلمة — «واي بروتين» مش «واي» أو «بروتين».
 * - لو مفيش ولا نتيجة: غلطة حرف واحد مسموحة (كريتين ← كرياتين).
 * - الترتيب: العينات (سعر صفر) آخر إلا لو كتب «عينه/مجاني» · النقط ·
 *   المتوفر قبل «نفد» · وعند التساوي الأكثر مبيعًا (ترتيب الفهرس).
 *
 * ⚠️ الموبايل: لوح كامل بحالة في التاريخ — زرار الرجوع بيقفله زي المنيو
 *    (نفس الأقفال: لينك جوه ← back الأول · pageshow · Escape). والـpopstate
 *    بتاع المنيو بيتجاهل حالتنا لأن `armed` بتاعه false — والعكس.
 * ⚠️ الفهرس (٣٠ك مضغوط) بيتجاب لما العميل يقرّب من البحث بس، ويتخزن
 *    ١٥ دقيقة في sessionStorage — صفر تكلفة على تحميل الصفحة.
 * ============================================================ */
(function () {
  var box = document.querySelector('[data-zfq]');
  if (!box) return;
  var form = box.querySelector('form');
  var input = form.querySelector('input[name="q"]');
  var pop = box.querySelector('[data-zfq-pop]');
  var live = box.querySelector('[data-zfq-live]');
  var openBtn = document.querySelector('[data-search-open]');
  var root = document.documentElement;
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SRC = base + 'collections/all?section_id=zf-search-index&sort_by=best-selling';
  var KEY = 'zfIdx1', SHOW = 4, BATCH = 12;
  var idx = null, fmt = '', ready = null, failed = false;
  var armed = false, skipPop = false, goingTo = null, popY = 0;

  /* نطق الكلمات الإنجليزي اللي في أسماء المنتجات والماركات (اتطلّعت من الفهرس
     نفسه ٣٠ أكتوبر) — «كريا اكس» تلاقي «Crea - X» و«whey» تلاقي «واي».
     مكتوبة متطبّعة (ا مش أ). كلمة إنجليزي جديدة في الأسماء؟ زوّدها هنا. */
  var ALIAS = {
    crea: 'كريا', creaa: 'كريا', x: 'اكس', triple: 'تريبل', power: 'باور',
    mass: 'ماس', gainer: 'جينر', whey: 'واي', protein: 'بروتين', creatine: 'كرياتين',
    azgard: 'ازجارد', nutrex: 'نيوتريكس', iso: 'ايزو', black: 'بلاك',
    carnitine: 'كارنيتين', big: 'بيج', pump: 'بامب', strong: 'استرونج',
    zero: 'زيرو', fat: 'فات'
  };
  var REV = {};
  Object.keys(ALIAS).forEach(function (k) { REV[ALIAS[k]] = k; });

  /* ---------- التطبيع والمطابقة ---------- */
  function norm(s) {
    return String(s || '').toLowerCase()
      .replace(/[ً-ٰٟـ]/g, '')
      .replace(/[أإآٱ]/g, 'ا').replace(/ة/g, 'ه').replace(/ى/g, 'ي')
      .replace(/ؤ/g, 'و').replace(/ئ/g, 'ي')
      .replace(/[٠-٩]/g, function (d) { return d.charCodeAt(0) - 1632; })
      /* ⚠️ مش \p{L} بعلامة u — متصفح قديم مابيدعمهاش بيرفض theme.js **كله** */
      .replace(/[^a-z0-9ء-يٮ-ۓ]+/g, ' ').trim();
  }
  function bare(w) { return w.length > 4 && w.indexOf('ال') === 0 ? w.slice(2) : w; }
  function words(s) {
    var out = [];
    norm(s).split(' ').forEach(function (w) {
      if (!w) return;
      out.push(w);
      if (bare(w) !== w) out.push(bare(w));
      if (ALIAS[w]) out.push(ALIAS[w]);
      if (REV[w]) out.push(REV[w]);
    });
    return out;
  }
  function tokens(q) { return norm(q).split(' ').filter(Boolean).map(bare); }

  /* مسافة تعديل ≤ ١ (حرف زيادة/ناقص/مختلف) */
  function near(a, b) {
    var la = a.length, lb = b.length, i = 0, j = 0, d = 0;
    if (Math.abs(la - lb) > 1) return false;
    while (i < la && j < lb) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++d > 1) return false;
      if (la > lb) i++; else if (lb > la) j++; else { i++; j++; }
    }
    return d + (la - i) + (lb - j) <= 1;
  }
  /* ٢ = كلمة كاملة · ١ = بداية كلمة · ٠.٥ = بغلطة حرف */
  /* ⚠️ أحسن تطابق في الكلمات كلها مش أول واحد: «كريا» بتبدأ بيها «كرياتين»
     (١) قبل ما نوصل لـ«كريا» الكاملة اللي جاية من نطق Crea (٢) — من غيرها
     البوكسات كانت بتسبق منتج Crea - X نفسه */
  function hit(t, W, fuzzy) {
    var best = 0;
    for (var k = 0; k < W.length; k++) {
      var w = W[k];
      if (w === t) return 2;
      if (w.indexOf(t) === 0) best = 1;
      else if (!best && fuzzy && t.length >= 4 && (near(t, w) || near(t, w.slice(0, t.length)) || near(t, w.slice(0, t.length + 1)))) best = 0.5;
    }
    return best;
  }

  function search(q) {
    var T = tokens(q);
    if (!T.length) return [];
    var wantFree = /عينه|مجان/.test(norm(q));
    function run(fuzzy) {
      var res = [];
      idx.forEach(function (it) {
        var s = 0;
        for (var k = 0; k < T.length; k++) {
          var h = hit(T[k], it.W, fuzzy) * 3 || hit(T[k], it.B, fuzzy) * 2 || hit(T[k], it.G, fuzzy);
          if (!h) return;
          s += h;
        }
        if (it.W[0] && it.W[0].indexOf(T[0]) === 0) s += 2;
        res.push({ it: it, s: s });
      });
      return res;
    }
    var res = run(false);
    if (!res.length) res = run(true);
    res.sort(function (a, b) {
      return (wantFree ? 0 : (a.it.p === 0) - (b.it.p === 0))
        || (b.s - a.s)
        || (b.it.a - a.it.a)
        || (a.it.n - b.it.n);
    });
    return res.map(function (r) { return r.it; });
  }

  /* ---------- الفهرس ---------- */
  function use(d) {
    fmt = d.f || '';
    idx = d.items.map(function (it, n) {
      it.n = n;
      it.W = words(it.t);
      it.B = words(it.v + ' ' + it.y);
      it.G = words(it.g);
      return it;
    });
  }
  function chunk(n) {
    return fetch(SRC + '&page=' + n, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      /* JSON خام جوه <div> بتاع السكشن — بنقصّه من غير ما نفكّ HTML */
      .then(function (s) { return JSON.parse(s.slice(s.indexOf('>') + 1, s.lastIndexOf('</div>'))); });
  }
  /* وعد واحد للفهرس — اللوح وصفحة النتايج بيستنوه هو نفسه */
  function load() {
    if (ready) return ready;
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && Date.now() - c.at < 15 * 60 * 1000) { use(c); ready = Promise.resolve(); return ready; }
    } catch (e) { /* التخزين مقفول — نجيبه من السيرفر */ }
    ready = chunk(1).then(function (first) {
      var rest = [];
      for (var n = 2; n <= first.pages; n++) rest.push(chunk(n));
      return Promise.all(rest).then(function (more) {
        var d = { at: Date.now(), f: first.f,
          items: more.reduce(function (all, m) { return all.concat(m.items); }, first.items) };
        try { sessionStorage.setItem(KEY, JSON.stringify(d)); } catch (e) { /* مش مهم */ }
        use(d);
      });
    }).catch(function () { failed = true; });
    ready.then(function () { if (input.value && (box.classList.contains('open') || document.activeElement === input)) render(); });
    return ready;
  }

  /* ---------- الرسم ---------- */
  function money(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    if (!fmt) return amount;
    return fmt
      .replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, Number(amount).toLocaleString('en-EG'))
      .replace(/<[^>]+>/g, '');
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function item(it) {
    var a = el('a', 'zfq-item' + (it.a ? '' : ' out'));
    a.href = it.u;
    var ph = el('span', 'zfq-ph');
    if (it.i) {
      var img = el('img');
      img.src = it.i; img.alt = ''; img.width = 56; img.height = 56;
      img.loading = 'lazy'; img.decoding = 'async';
      ph.appendChild(img);
    }
    var tx = el('span', 'zfq-tx');
    tx.appendChild(el('b', null, it.t));
    var pr = el('span', 'zfq-pr', it.p === 0 ? 'مجانًا' : (it.m ? 'من ' : '') + money(it.p));
    if (it.c > it.p) pr.appendChild(el('s', null, money(it.c)));
    if (!it.a) pr.appendChild(el('i', null, 'نفد'));
    tx.appendChild(pr);
    a.appendChild(ph);
    a.appendChild(tx);
    return a;
  }
  function resultsUrl(q) {
    return form.action + '?q=' + encodeURIComponent(q.trim()) + '&options%5Bprefix%5D=last';
  }

  /* اللوح: فاضي قبل الكتابة · ٤ نتايج · زرار «كل النتايج» لو فيه أكتر */
  function render() {
    var q = input.value;
    pop.textContent = '';
    if (!tokens(q).length) { hide(); live.textContent = ''; return; }
    if (pop.hidden) popY = window.scrollY;
    pop.hidden = false;
    input.setAttribute('aria-expanded', 'true');
    if (!idx) {
      pop.appendChild(el('p', 'zfq-note', failed ? 'دوس Enter وهيوديك لصفحة النتايج.' : 'بنجهّز النتايج…'));
      return;
    }
    var res = search(q);
    if (!res.length) {
      pop.appendChild(el('p', 'zfq-note', 'مفيش نتيجة لـ «' + q.trim() + '» — جرّب كلمة تانية.'));
      live.textContent = 'مفيش نتايج';
      return;
    }
    var rows = el('div', 'zfq-list');
    res.slice(0, SHOW).forEach(function (it) { rows.appendChild(item(it)); });
    pop.appendChild(rows);
    if (res.length > SHOW) {
      var all = el('a', 'zfq-all', 'شوف كل النتايج (' + res.length + ')');
      all.href = resultsUrl(q);
      pop.appendChild(all);
    }
    live.textContent = res.length + ' نتيجة';
  }

  /* ---------- الفتح والقفل ---------- */
  function hide() {
    pop.hidden = true;
    input.setAttribute('aria-expanded', 'false');
  }
  function openPanel() {
    box.classList.add('open');
    root.classList.add('zfq-on');
    root.style.overflow = 'hidden';
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    load();
    render();
    input.focus();
    try { history.pushState({ zfSearch: 1 }, ''); armed = true; } catch (e) { /* مش مهم */ }
  }
  function closePanel(keepHistory) {
    if (!box.classList.contains('open')) return;
    box.classList.remove('open');
    root.classList.remove('zfq-on');
    root.style.overflow = '';
    if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus({ preventScroll: true }); }
    hide();
    if (keepHistory || !armed) return;
    armed = false;
    skipPop = true;
    try { history.back(); } catch (e) { skipPop = false; }
  }
  /* رايح لصفحة تانية واللوح مفتوح: ننضّف الحالة الحارسة **قبل** ما نروح (زي
     المنيو) — وإلا ضغطة رجوع من الصفحة الجديدة بتضيع في العدم */
  function leaveTo(url) {
    goingTo = url;
    armed = false;
    try { history.back(); } catch (err) { goingTo = null; window.location.href = url; }
  }

  if (openBtn) openBtn.addEventListener('click', openPanel);
  box.querySelector('[data-search-close]').addEventListener('click', function () { closePanel(); });
  /* موبايل: الضغط على الضلمة اللي تحت اللوح بيقفله */
  box.addEventListener('click', function (e) {
    if (e.target === box && box.classList.contains('open')) closePanel();
  });

  input.addEventListener('focus', function () { load(); render(); });
  input.addEventListener('input', function () { load(); render(); });
  /* Enter بيروح لصفحة النتايج عادي (الفورم نفسه) — وهناك بترتيبنا */
  form.addEventListener('submit', function (e) {
    if (!armed || !tokens(input.value).length) return;
    e.preventDefault();
    leaveTo(resultsUrl(input.value));
  });

  pop.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a || !armed || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
    e.preventDefault();
    leaveTo(a.href);
  });

  box.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (box.classList.contains('open')) closePanel(); else { hide(); input.blur(); }
      return;
    }
    if ((e.key !== 'ArrowDown' && e.key !== 'ArrowUp') || pop.hidden) return;
    var items = [].slice.call(pop.querySelectorAll('a'));
    if (!items.length) return;
    var i = items.indexOf(document.activeElement);
    e.preventDefault();
    if (e.key === 'ArrowDown') (items[i + 1] || items[0]).focus();
    else if (i <= 0) input.focus(); else items[i - 1].focus();
  });

  /* ديسكتوب: ضغطة بره أو Tab لبره بيقفل النتايج */
  document.addEventListener('click', function (e) {
    if (pop.hidden || box.classList.contains('open') || box.contains(e.target)) return;
    hide();
  });
  box.addEventListener('focusout', function (e) {
    if (e.relatedTarget && !box.contains(e.relatedTarget) && !box.classList.contains('open')) hide();
  });
  /* ديسكتوب: نزل أو طلع والقايمة مفتوحة = خلص منها. الهيدر لاصق ومابيستخباش
     وهي مفتوحة، فكانت بتفضل طايرة فوق المنتجات (axe مسكها ٣٠ أكتوبر) */
  window.addEventListener('scroll', function () {
    if (pop.hidden || box.classList.contains('open')) return;
    if (Math.abs(window.scrollY - popY) < 120) return;
    hide();
    if (document.activeElement === input) input.blur();
  }, { passive: true });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted && box.classList.contains('open')) { armed = false; closePanel(true); }
  });
  window.addEventListener('popstate', function () {
    if (goingTo) { var u = goingTo; goingTo = null; window.location.href = u; return; }
    if (skipPop) { skipPop = false; return; }
    if (!armed) return;                 /* مش حالتنا */
    armed = false;
    closePanel(true);
  });

  /* ---------- أمثلة بتتكتب وتتمسح في الخانة (طلب سمير) ---------- */
  (function () {
    var hints = (input.getAttribute('data-hints') || '').split(/[،,]/)
      .map(function (s) { return s.trim(); }).filter(Boolean);
    if (!hints.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var plain = input.getAttribute('placeholder') || '';
    var wi = 0, ci = 0, del = false;
    function tick() {
      /* بيقف لو العميل كتب، أو الخانة مش باينة (لوح الموبايل مقفول)، أو التاب
         مش قدامه — مفيش شغل في الخلفية */
      if (input.value || document.hidden || !input.offsetParent) {
        input.setAttribute('placeholder', plain);
        ci = 0; del = false;
        setTimeout(tick, 700);
        return;
      }
      var w = hints[wi], wait = del ? 35 : 80;
      ci += del ? -1 : 1;
      input.setAttribute('placeholder', w.slice(0, ci));
      if (!del && ci >= w.length) { del = true; wait = 1400; }
      else if (del && ci <= 0) { del = false; wi = (wi + 1) % hints.length; wait = 300; }
      setTimeout(tick, wait);
    }
    tick();
  })();

  /* ---------- صفحة /search: نفس الصفحة والكارت، بترتيبنا ---------- */
  var results = document.querySelector('[data-zfq-results]');
  if (!results) return;
  var server = results.querySelector('[data-zfq-server]');
  var grid = results.querySelector('[data-zfq-grid]');
  var moreBtn = results.querySelector('[data-zfq-more]');
  var count = document.querySelector('[data-zfq-count]');
  var q0 = results.getAttribute('data-q') || '';
  var found = [], shown = 0;
  /* حاجة وقعت؟ نتايج شوبيفاي تظهر على طول بدل ما تستنى الـ٤ ثواني */
  function giveUp() { if (server) server.classList.add('zfq-show'); }
  function cards(list) {
    var hs = list.map(function (it) { return decodeURIComponent(it.u.split('/products/')[1] || ''); }).join(' ');
    return fetch(base + 'search?type=product&section_id=zf-search-cards&q=' + encodeURIComponent(hs), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (s) {
        /* DOMParser = مستند خامل: الصور مابتتحمّلش غير لما الكروت تدخل الصفحة */
        var sec = new DOMParser().parseFromString(s, 'text/html').querySelector('.shopify-section');
        return sec ? sec.innerHTML : '';
      });
  }
  function more() {
    var next = found.slice(shown, shown + BATCH);
    if (!next.length) return Promise.resolve();
    moreBtn.hidden = true;
    return cards(next).then(function (html) {
      grid.insertAdjacentHTML('beforeend', html);
      shown += next.length;
      moreBtn.hidden = shown >= found.length;
    });
  }
  moreBtn.addEventListener('click', function () {
    more().catch(function () { moreBtn.hidden = false; });
  });
  load().then(function () {
    if (!idx) { giveUp(); return; }
    found = search(q0);
    var done = function () {
      /* استلمنا — نشيل نسخة شوبيفاي عشان مايبقاش فيه نتيجتين */
      if (server) { server.remove(); server = null; }
      if (count) count.textContent = found.length + ' نتيجة للبحث عن: «' + q0 + '»';
    };
    if (!found.length) {
      done();
      var t = results.querySelector('[data-zfq-empty]');
      if (t) results.appendChild(t.content.cloneNode(true));
      return;
    }
    return more().then(done);
  }).catch(giveUp);
})();

/* ============================================================
 * وصف القسم: «اقرا أكتر» على الموبايل — base.css بيقصّه ٣ سطور عشان
 * المنتجات تحته ماتتهزّش لما خط Almarai يوصل (CLS ٠.٢٤ ← اتقاس ٣٠ أكتوبر)
 * ============================================================ */
(function () {
  var box = document.querySelector('[data-intro]');
  var btn = box && box.querySelector('[data-intro-more]');
  if (!btn) return;
  function open() {
    box.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');
  }
  /* الزرار بيظهر بس لو فيه كلام مقصوص فعلًا (الديسكتوب مابيقصّش) */
  if (box.scrollHeight > box.clientHeight + 2) btn.hidden = false;
  btn.addEventListener('click', open);
  /* لينك جوه الجزء المقصوص خد التركيز بالكيبورد؟ افتح — مايبقاش تركيز على حاجة مش باينة */
  box.addEventListener('focusin', function (e) { if (e.target !== btn) open(); });
})();
